module.exports = __webpack_public_path__ + "static/media/1.f6cf6ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/1.png
// module id = 1506
// module chunks = 0